import { createFileRoute } from "@tanstack/react-router";
import AdminVideosPage from "@/admin/pages/videos";

export const Route = createFileRoute("/admin/videos")({
  component: AdminVideosPage,
});
